<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 数据统计 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <el-button class="filter-item" style="background-color: #00bfbf; color: white; float: right" @click="setTime" v-if="time_button">设置时间</el-button>
      <receptionTimePopup
        :timeOptions="timeOptionList"
        :setTimeShow="setTimeShow"
        @deleteTime="deleteTime"
        @addTime="addTime"
        @removeTime="removeTime"
        @sureTime="sureTime"
        @closeTimeShow="closeTimeShow"
      >
      </receptionTimePopup>
      <div class="app-container">
        <el-header class="header-id">
          <span v-if="timeTypeShow">时间类型：</span>
          <el-select v-model="timeType" v-if="timeTypeShow" @change="changeTimeType" filterable placeholder="" style="margin-right: 20px">
            <el-option v-for="item in timeOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
          <el-date-picker
            v-model="value1"
            :type="dateTypeRange"
            :format="formatStyle"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="margin-right: 20px"
            :picker-options="pickerOptions"
            @blur="time"
          ></el-date-picker>
          <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button class="filter-item" type="warning" @click="handleExport">导出</el-button>
          <el-button class="filter-item" type="warning" @click="handleReset" style="margin-right: 10px">重置</el-button>
          <span style="font-size: 15px; margin-left: 20px">数据类型：</span>
          <el-select v-model="listQuery.data_type" @change="changeType" filterable placeholder="请选择" style="margin-right: 20px">
            <el-option v-for="item in daateTypeOptions" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-header>

        <el-main>
          <!-- 按钮点击统计 -->
          <el-table v-if="originalTableShow" border v-loading="listLoading" :data="tableData" :span-method="objectSpanMethod" style="width: 100%" min-height="200" max-height="1000">
            <el-table-column v-for="item of tableColumn0" :key="item.prop" :prop="item.prop" :label="item.label" align="center" />
          </el-table>

          <!-- 大分类-->
          <el-table v-if="bigTableShow" border v-loading="listLoading" :data="tableData" style="width: 100%" min-height="200" max-height="1000">
            <el-table-column prop="calc_date" label="时间" width="250" />
            <el-table-column v-for="item of tableColumn1" :key="item.prop" :prop="item.prop" :label="item.label" align="center" />
          </el-table>

          <!-- 小分类-->
          <el-table v-if="littleTableShow" border v-loading="listLoading" :data="tableData" style="width: 100%" min-height="200" max-height="1000">
            <el-table-column prop="calc_date" label="时间" width="250" />
            <el-table-column v-for="item of tableColumn2" :key="item.prop" :prop="item.prop" :label="item.label" align="center" />
          </el-table>

          <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="handleList" />
        </el-main>
      </div>
    </div>
  </div>
</template>

<script>
import { dataAnalysis } from '@/api/work_question';
import { getTimeApi, setTimeApi } from "@/api/work_kefu.js";
import Pagination from '@/components/pagination/index';
import receptionTimePopup from "@/components/common/receptionTimePopup";
import { export_json_to_excel } from '@/vendor/Export2Excel';
import moment from 'moment';
export default {
  components: { Pagination, receptionTimePopup },
  name: 'data_statistics',
  computed: {
    originalTableShow() {
      let show = false;
      if (this.listQuery.data_type == 1) {
        show = true;
      }
      return show;
    },
    bigTableShow() {
      let show = false;
      if (this.listQuery.data_type == 2) {
        show = true;
      }
      return show;
    },
    littleTableShow() {
      let show = false;
      if (this.listQuery.data_type == 3) {
        show = true;
      }
      return show;
    },
  },
  data() {
    return {
      listLoading: false,
      total: 0,
      tableData: [],
      tableColumn0: [
        {
          prop: 'census_date',
          label: '时间',
        },
        {
          prop: 'type',
          label: '数据类型',
        },
        {
          prop: 'payment_question',
          label: '充值异常',
        },
        {
          prop: 'account_pwd',
          label: '找回账号密码',
        },
        {
          prop: 'account_application',
          label: '账号异常',
        },
        {
          prop: 'satisfaction',
          label: '投诉/表扬',
        },
        {
          prop: 'service_contact',
          label: '在线客服-公众号',
        },
        {
          prop: 'my_games_from_wechat',
          label: '找回游戏-公众号（*）',
        },
        {
          prop: 'my_games_from_sdk',
          label: '找回游戏-sdk（*）',
        },
        {
          prop: 'game_download_from_wechat',
          label: '游戏下载-公众号（*）',
        },
        {
          prop: 'game_download_from_sdk',
          label: '游戏下载-sdk（*）',
        },
        {
          prop: 'service_contact_from_sdk',
          label: '在线客服-sdk（*）',
        },
        {
          prop: 'service_vip',
          label: 'vip跳转',
        },
        {
          prop: 'share_game',
          label: '游戏分享',
        },
        {
          prop: 'play_together_click',
          label: '一起玩-点击',
        },
        {
          prop: 'play_together_copy',
          label: '一起玩-复制',
        },
      ],
      tableColumn1: [
        {
          prop: 'summary',
          label: '总计',
        },
        {
          prop: 'payment_question_wechat',
          label: '充值异常 - 公众号',
        },
        {
          prop: 'payment_question_sdk',
          label: '充值异常 - sdk',
        },
        {
          prop: 'account_pwd_wechat',
          label: '找回账号密码 - 公众号',
        },
        {
          prop: 'account_pwd_sdk',
          label: '找回账号密码 - sdk',
        },
        {
          prop: 'account_application_wechat',
          label: '账号异常 - 公众号',
        },
        {
          prop: 'account_application_sdk',
          label: '账号异常 - sdk',
        },
        {
          prop: 'satisfaction_wechat',
          label: '投诉/表扬 - 公众号',
        },
        {
          prop: 'satisfaction_sdk',
          label: '投诉/表扬 - sdk',
        },
      ],
      tableColumn2: [
        {
          prop: 'summary',
          label: '总计',
        },
        {
          prop: 'account_banned_wechat',
          label: '账号封禁申诉 - 公众号',
        },
        {
          prop: 'account_banned_sdk',
          label: '账号封禁申诉 - sdk',
        },
        {
          prop: 'account_stolen_wechat',
          label: '盗号申诉 - 公众号',
        },
        {
          prop: 'account_stolen_sdk',
          label: '盗号申诉 - sdk',
        },
        {
          prop: 'chat_banned_wechat',
          label: '禁言申诉 - 公众号',
        },
        {
          prop: 'chat_banned_sdk',
          label: '禁言申诉 - sdk',
        },
        {
          prop: 'game_content_abnormal_wechat',
          label: '游戏内问题异常 - 公众号',
        },
        {
          prop: 'game_content_abnormal_sdk',
          label: '游戏内问题异常 - sdk',
        },
        {
          prop: 'game_login_abnormal_wechat',
          label: '游戏登录异常 - 公众号',
        },
        {
          prop: 'game_login_abnormal_sdk',
          label: '游戏登录异常 - sdk',
        },
        {
          prop: 'bugs_wechat',
          label: 'bug举报类 - 公众号',
        },
        {
          prop: 'bugs_sdk',
          label: 'bug举报类 - sdk',
        },
        {
          prop: 'abuse_words_wechat',
          label: '游戏内骂人举报 - 公众号',
        },
        {
          prop: 'abuse_words_sdk',
          label: '游戏内骂人举报 - sdk',
        },
        {
          prop: 'merge_suggestion_wechat',
          label: '合服建议 - 公众号（*）',
        },
        {
          prop: 'merge_suggestion_sdk',
          label: '合服建议 - sdk（*）',
        },
        {
          prop: 'activity_suggestion_wechat',
          label: '活动建议 - 公众号（*）',
        },
        {
          prop: 'activity_suggestion_sdk',
          label: '活动建议 - sdk（*）',
        },
        {
          prop: 'version_suggestion_wechat',
          label: '版本建议 - 公众号（*）',
        },
        {
          prop: 'version_suggestion_sdk',
          label: '版本建议 - sdk（*）',
        },
        {
          prop: 'other_suggestion_wechat',
          label: '其他建议 - 公众号（*）',
        },
        {
          prop: 'other_suggestion_sdk',
          label: '其他建议 - sdk（*）',
        },
        {
          prop: 'account_found_wechat',
          label: '账号找回 - 公众号（*）',
        },
        {
          prop: 'account_found_sdk',
          label: '账号找回 - sdk（*）',
        },
        {
          prop: 'password_found_wechat',
          label: '密码找回 - 公众号（*）',
        },
        {
          prop: 'password_found_sdk',
          label: '密码找回 - sdk（*）',
        },
        {
          prop: 'nothing_remember_wechat',
          label: '什么都不记得了 - 公众号（*）',
        },
        {
          prop: 'nothing_remember_sdk',
          label: '什么都不记得了 - sdk（*）',
        },
      ],
      listQuery: {
        page: 1,
        limit: 10,
        census_date_start: undefined,
        census_date_end: undefined,
        data_type: 1,
      },
      // 时间范围选择
      timeType: 2,
      timeTypeShow: false,
      timeOptions: [
        {
          name: '天',
          id: 1,
        },
        {
          name: '小时',
          id: 2,
        },
      ],
      daateTypeOptions: [
        {
          name: '按钮点击统计',
          id: 1,
        },
        {
          name: '工单大分类统计',
          id: 2,
        },
        {
          name: '工单小分类统计',
          id: 3,
        },
      ],
      value1: [],
      dateTypeRange: 'daterange',
      formatStyle: 'yyyy-MM-dd',
      // 限制选择未来的时间
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      time_button: false,
      setTimeShow: false,
      timeOptionList: []
    };
  },
  created() {
    this.handleList();
  },
  methods: {
    async handleExport() {
      this.listLoading = true;
      let allData = {
        is_export: 1,
        data_type: this.listQuery.data_type,
      };
      if (this.listQuery.data_type != 1) {
        if (this.value1 == null || this.value1.length == 0) {
          allData.begin_time = data.end_time = '';
        } else {
          if (this.timeType == 1) {
            allData.begin_time = this.changeTimeStyle(1, 'date');
            allData.end_time = this.changeTimeStyle(2, 'date');
          } else {
            allData.begin_time = this.changeTimeStyle(1, 'time');
            allData.end_time = this.changeTimeStyle(2, 'time');
          }
        }
        allData.statistics_type = this.timeType;
        this.$delete(allData, 'census_date_start');
        this.$delete(allData, 'census_date_end');
      } else {
        if (this.value1 == null || this.value1.length == 0) {
          allData.census_date_start = allData.census_date_end = '';
        } else {
          allData.census_date_start = this.changeTimeStyle(1, 'date');
          allData.census_date_end = this.changeTimeStyle(2, 'date');
        }
      }
      const r = await dataAnalysis(allData);
      if (r.data.code !== 200) return;
      let tHeader = [],
        filterVal = [];
      if (this.listQuery.data_type == 1) {
        tHeader = ['时间', '数据类型', '充值问题', '账号密码找回', '账号申诉', '游戏异常', '游戏建议/玩法', '违规举报', '客服验证', '投诉/表扬', '联系客服', '联系客服-SDK'];
        filterVal = [
          'census_date',
          'type',
          'payment_question',
          'account_pwd',
          'account_application',
          'game_exception',
          'game_suggestion',
          'tip_off',
          'service_validation',
          'satisfaction',
          'service_contact',
          'service_contact_from_sdk',
        ];
      } else if (this.listQuery.data_type == 2) {
        tHeader = [
          '时间',
          '汇总',
          '充值问题 - 公众号',
          '充值问题 - sdk',
          '账号密码找回 - 公众号',
          '账号密码找回 - sdk',
          '账号申诉 - 公众号',
          '账号申诉 - sdk',
          '游戏异常 - 公众号',
          '游戏异常 - sdk',
          '游戏建议 - 公众号',
          '游戏建议 - sdk',
          '违规举报 - 公众号',
          '违规举报 - sdk',
          '客服投诉/表扬建议 - 公众号',
          '客服投诉/表扬建议 - sdk',
          '其他问题 - 公众号',
          '其他问题 - sdk',
        ];
        filterVal = [
          'calc_date',
          'summary',
          'payment_question_wechat',
          'payment_question_sdk',
          'account_pwd_wechat',
          'account_pwd_sdk',
          'account_application_wechat',
          'account_application_sdk',
          'game_exception_wechat',
          'game_exception_sdk',
          'game_suggestion_wechat',
          'game_suggestion_sdk',
          'tip_off_wechat',
          'tip_off_sdk',
          'satisfaction_wechat',
          'satisfaction_sdk',
          'others_wechat',
          'others_sdk',
        ];
      } else if (this.listQuery.data_type == 3) {
        tHeader = [
          '时间',
          '汇总',
          '账号封禁申诉 - 公众号',
          '账号封禁申诉 - sdk',
          '盗号申诉 - 公众号',
          '盗号申诉 - sdk',
          '禁言申诉 - 公众号',
          '禁言申诉 - sdk',
          '游戏内问题异常 - 公众号',
          '游戏内问题异常 - sdk',
          '游戏登录异常 - 公众号',
          '游戏登录异常 - sdk',
          'bug举报类 - 公众号',
          'bug举报类 - sdk',
          '游戏内骂人举报 - 公众号',
          '游戏内骂人举报 - sdk',
        ];
        filterVal = [
          'calc_date',
          'summary',
          'account_banned_wechat',
          'account_banned_sdk',
          'account_stolen_wechat',
          'account_stolen_sdk',
          'chat_banned_wechat',
          'chat_banned_sdk',
          'game_content_abnormal_wechat',
          'game_content_abnormal_sdk',
          'game_login_abnormal_wechat',
          'game_login_abnormal_sdk',
          'bugs_wechat',
          'bugs_sdk',
          'abuse_words_wechat',
          'abuse_words_sdk',
        ];
      }
      const list = r.data.data.data;
      const data = this.formatJson(filterVal, list);
      export_json_to_excel({ header: tHeader, data, filename: '数据统计' });
      this.listLoading = false;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        }),
      );
    },
    handleSearch() {
      this.listQuery.page = 1;
      this.handleList();
    },
    handleReset() {
      this.listQuery.census_date_start = undefined;
      this.listQuery.census_date_end = undefined;
      this.value1 = [];
      this.timeType = '';
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      this.handleList();
    },
    changeTimeStyle(item, type) {
      if (item == 1 && type == 'time') {
        return moment(this.listQuery.census_date_start).format('yyyy-MM-DD HH');
      }
      if (item == 2 && type == 'time') {
        return moment(this.listQuery.census_date_end).format('yyyy-MM-DD HH');
      }
      if (item == 1 && type == 'date') {
        return moment(this.listQuery.census_date_start).format('yyyy-MM-DD');
      }
      if (item == 2 && type == 'date') {
        return moment(this.listQuery.census_date_end).format('yyyy-MM-DD');
      }
    },
    async handleList() {
      this.listLoading = true;
      let data = JSON.parse(JSON.stringify(this.listQuery));
      if (this.listQuery.data_type != 1) {
        if (this.value1 == null || this.value1.length == 0) {
          data.begin_time = data.end_time = '';
        } else {
          if (this.timeType == 1) {
            data.begin_time = this.changeTimeStyle(1, 'date');
            data.end_time = this.changeTimeStyle(2, 'date');
          } else {
            data.begin_time = this.changeTimeStyle(1, 'time');
            data.end_time = this.changeTimeStyle(2, 'time');
          }
        }
        data.statistics_type = this.timeType;
        this.$delete(data, 'census_date_start');
        this.$delete(data, 'census_date_end');
      } else {
        if (this.value1 == null || this.value1.length == 0) {
          data.census_date_start = data.census_date_end = '';
        } else {
          data.census_date_start = this.changeTimeStyle(1, 'date');
          data.census_date_end = this.changeTimeStyle(2, 'date');
        }
      }
      const r = await dataAnalysis(data);
      if (r.data.code !== 200) return;
      if (this.listQuery.data_type == 1) {
        this.tableData = r.data.data.data.map((item) => {
          item.my_games_from_sdk = item.my_games_from_sdk || 0;
          item.game_download_from_sdk = item.game_download_from_sdk || 0;
          item.my_games_from_wechat = item.my_games_from_wechat || 0;
          item.game_download_from_wechat = item.game_download_from_wechat || 0;
          item.follow_official_accounts_from_sdk = item.follow_official_accounts_from_sdk || 0;
          item.service_contact_from_sdk = item.service_contact_from_sdk || 0;
          item.service_vip = item.service_vip || 0;
          item.share_game = item.share_game || 0;
          item.play_together_click = item.play_together_click || 0;
          item.play_together_copy = item.play_together_copy || 0;
          return item;
        });
      } else {
        this.tableData = r.data.data.data;
      }
      this.time_button = r.data.data.time_button;
      this.total = r.data.data.total;
      this.listLoading = false;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    time() {
      if (!this.value1) return;
      this.listQuery.census_date_start = this.value1[0];
      this.listQuery.census_date_end = this.value1[1];
    },
    changeType(value) {
      if (value == 2 || value == 3) {
        this.timeTypeShow = true;
        this.dateTypeRange = 'datetimerange';
        this.formatStyle = 'yyyy-MM-dd HH';
      } else {
        this.timeTypeShow = false;
        this.dateTypeRange = 'daterange';
        this.formatStyle = 'yyyy-MM-dd';
      }
      this.resetDta();
      this.handleList();
    },
    changeTimeType(value) {
      if (value == 1) {
        this.dateTypeRange = 'daterange';
        this.formatStyle = 'yyyy-MM-dd';
      } else {
        this.dateTypeRange = 'datetimerange';
        this.formatStyle = 'yyyy-MM-dd HH';
      }
      this.value1 = null;
    },
    resetDta() {
      this.listQuery.limit = 10;
      this.listQuery.page = 1;
      this.value1 = [];
      this.listQuery.census_date_start = '';
      this.listQuery.census_date_end = '';
      this.timeType = 2;
    },
    // 时间
    setTime() {
      this.setTimeShow = true;
      this.timeOptionList = [];
      getTimeApi({ config_key: "service.vip_time_range" })
        .then(response => {
          for (let item of response.data.data) {
            let m = {
              value: [],
              id: new Date()
            }
            let time = item.split('-')
            m.value = time;
            this.timeOptionList.push(m);
          }
        })
        .catch(error => { })
    },
    deleteTime(item) {
      for (let i = 0; i < this.timeOptionList.length; i++) {
        if (this.timeOptionList[i].id == item.id) {
          this.timeOptionList.splice(i, 1);
        }
      }
    },
    addTime() {
      let m = {
        value: ["00:00", "23:59"],
        id: new Date()
      }
      this.timeOptionList.push(m);
    },
    removeTime() {
      this.setTimeShow = false;
    },
    closeTimeShow() {
      this.setTimeShow = false;
    },
    sureTime() {
      let data = {
        config_values: [],
        config_key: ""
      }
      data.config_key = "service.vip_time_range";
      for (let item of this.timeOptionList) {
        let time = "";
        if (!(item.value[0] == "00:00" && item.value[1] == "23:59")) {
          time = item.value[0] + "-" + item.value[1];
          data.config_values.push(time)
        }
      }
      setTimeApi(data)
        .then(response => {
          if (response.data.code == 200) {
            this.setTimeShow = false;
            this.$message.success(response.data.message)
          }
          else {
            this.$message.error(response.data.message)
          }
        })
        .catch(error => { })
    }
  },
};
</script>

<style>
.title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 20px;
}
.header-id {
  font-size: 14px;
}
</style>